import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './Metadata.module.scss';

const Metadata = ({ theme = {}, text }) => (
  <div className={classNames(style.metaContainer, theme.metaContainer)}>
    <span className={classNames(style.meta, theme.meta)}>{text}</span>
  </div>
);

Metadata.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default Metadata;
